import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

// Configuration des routes avec leurs labels et parents
const routeConfig = {
  '/': { label: 'Tableau de bord', icon: Home },
  '/calendar': { label: 'Calendrier', parent: '/' },
  '/reservations': { label: 'Réservations', parent: '/' },
  '/guests': { label: 'Clients', parent: '/' },
  '/sales': { label: 'Ventes', parent: '/' },
  '/products': { label: 'Produits & Services', parent: '/' },
  '/expenses': { label: 'Dépenses', parent: '/' },
  '/payouts': { label: 'Versements', parent: '/' },
  '/cash': { label: 'Fond de caisse', parent: '/' },
  '/employees': { label: 'RH', parent: '/' },
  '/reports': { label: 'Rapports', parent: '/' },
  '/users': { label: 'Utilisateurs', parent: '/' },
  '/settings': { label: 'Paramètres', parent: '/' },
  '/configuration': { label: 'Configuration', parent: '/settings' },
};

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  
  // Build breadcrumb trail
  const buildTrail = () => {
    const trail = [];
    let currentPath = location.pathname;
    
    // Add current page
    const currentConfig = routeConfig[currentPath];
    if (currentConfig) {
      trail.unshift({ path: currentPath, ...currentConfig });
      
      // Walk up parent chain
      while (currentConfig?.parent) {
        const parentPath = currentConfig.parent;
        const parentConfig = routeConfig[parentPath];
        if (parentConfig) {
          trail.unshift({ path: parentPath, ...parentConfig });
        }
        currentPath = parentPath;
        break; // Only go one level up for simplicity
      }
    }
    
    // Add detail context if there's an ID in URL
    const entityId = searchParams.get('id');
    if (entityId && trail.length > 0) {
      trail.push({ 
        label: `Détail #${entityId}`, 
        path: `${location.pathname}?id=${entityId}`,
        isDetail: true 
      });
    }
    
    return trail;
  };
  
  const trail = buildTrail();
  
  // Don't show breadcrumb on dashboard
  if (location.pathname === '/' || trail.length <= 1) {
    return null;
  }

  return (
    <nav className="flex items-center gap-1 text-sm text-muted-foreground mb-4" aria-label="Fil d'Ariane">
      {trail.map((item, index) => {
        const isLast = index === trail.length - 1;
        const Icon = item.icon;
        
        return (
          <React.Fragment key={item.path}>
            {index > 0 && (
              <ChevronRight className="w-4 h-4 text-muted-foreground/50" />
            )}
            {isLast ? (
              <span className="font-medium text-foreground flex items-center gap-1.5">
                {Icon && <Icon className="w-4 h-4" />}
                {item.label}
              </span>
            ) : (
              <button
                onClick={() => navigate(item.path)}
                className="hover:text-primary transition-colors flex items-center gap-1.5"
              >
                {Icon && <Icon className="w-4 h-4" />}
                {item.label}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
